import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import { AwsPdfResponse } from '../AwsGraphs';
import { formatNumber } from 'utils/formatNumber';

/**
 * Props for Header component.
 */
interface HeaderProps {
    data: AwsPdfResponse;
}

/**
 * Renders the header section for AWS graphs.
 * @param {HeaderProps} props - The props for the component.
 */
const Header: React.FC<HeaderProps> = ({ data }) => {
    const { t } = useTranslate();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { xs: 'flex-start', md: 'center' },
                justifyContent: 'space-between',
                position: 'relative',
                gap: 1
            }}
        >
            <Typography
                variant="h2"
                sx={{
                    fontWeight: 800,
                    fontSize: { xs: 32, md: 44 },
                    color: '#232B36',
                    lineHeight: 1.2,
                    flex: 1
                }}
            >
                <Box component="span" sx={{ color: '#EF11E9', fontWeight: 900, display: 'inline' }}>
                    {'Frust '}
                </Box>
                {t('pdf_success.header.savings_prefix') + ' '}
                <Box
                    component="span"
                    sx={{
                        color: '#fff',
                        fontWeight: 900,
                        display: 'inline',
                        background: '#EF11E9',
                        px: 1,
                        borderRadius: '6px'
                    }}
                >
                    ${formatNumber(data.possible_savings!)}
                </Box>{' '}
                {t('pdf_success.header.savings_suffix')}
            </Typography>
            <Typography
                variant="subtitle1"
                sx={{ mt: 2, color: '#232B36', fontWeight: 600, fontSize: { xs: 16, md: 24 }, lineHeight: 1.4 }}
            >
                {t('pdf_success.efficiency_subtitle', { count: 72 })}
            </Typography>
        </Box>
    );
};

export default Header;
